module.exports = __webpack_public_path__ + "img/BoD_01_Dr_Gerard_Ee.81dd5ef4.jpg";